// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Optimize$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Optimize.bs.js";
import * as JsonRulesEngine from "json-rules-engine";
function includeOperator(factValue, jsonValue) {
  return factValue.includes(jsonValue);
}
function notIncludeOperator(factValue, jsonValue) {
  return !factValue.includes(jsonValue);
}
function addCustomOperator(engineOb) {
  engineOb.addOperator("include", includeOperator);
  engineOb.addOperator("notInclude", notIncludeOperator);
}
var removeNullValues = function removeAllNullValues(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeAllNullValues);
  } else if (typeof obj === "object") {
    let obj2 = {};
    for (let k in obj) {
      if (obj[k] !== null) {
        let key = k === "type_" ? "type" : k;
        obj2[key] = removeAllNullValues(obj[k]);
      }
    }
    return obj2;
  } else {
    return obj;
  }
};
async function execute(rule, facts) {
  var ob = new JsonRulesEngine.Engine();
  addCustomOperator(ob);
  ob.addRule(removeNullValues(Curry._1(Optimize$ApiTypes.Experiment.Rule.t_encode, rule)));
  return await ob.run(facts);
}
export { includeOperator, notIncludeOperator, addCustomOperator, removeNullValues, execute };
/* Optimize-ApiTypes Not a pure module */